import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NowYouSay from './pages/NowYouSay';
import IsFor from './pages/IsFor';
import TraceALetter from './pages/TraceALetter';
import Home from './pages/Home';
import Layout from './components/Layout';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/nowyousay' element={<NowYouSay/>}/>
            <Route path='/isfor' element={<IsFor/>}/>
            <Route path='/tracealetter' element={<TraceALetter/>}/>
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
